import React from 'react'
import { Table, Tag, Form, Icon, Spin, Button, Tooltip, Modal, Col, Row, DatePicker, Select, Input } from 'antd';
import Pedidos from '../../services/Pedidos';
import CatalogosRequest from '../../services/Catalogos';
import { openNotification } from '../../util/notificaciones';
import DetallePedidosRealizados from './DetallePedidosRealizados';
import RecibirPedidoRealizado from './RecibirPedidoRealizado';
import moment from 'moment'
import 'moment/locale/es';
import CalificarPedido from './CalificarPedido';
import PedidosRequest from '../../services/Pedidos';
import EditarPedidoRealizado from './EditarPedidoRealizado';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';

moment.locale('es')

const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';


/**
 * Clase para visualizar los pedidos realizados
 */
class PedidosRealizados extends BaseComponent {
    state = {
        sitios: [],
        arrPedidosRealizados: [],
        arrPedidosRealizadosCopy: [],
        arrPedidosRealizadosFiltros: [],
        cargando: false,
        mostrarModalCancelar: false,
        disableBtnCancelar: false,
        objCancelarPedido: null,
        sitioPedidoSelected: undefined,
        filterTextPedidos: "",
        estatusSelected: undefined,
        fechaPedido: [],
        fechaVencimiento: [],
        datesPedido: [],
        datesVencimiento: [],
        arrEstatusPedidos: [],
        objPedidoSelected: null,
        mostrarModalRecibir: false,
        mostrarModalCalificar: false,
        tipo_modal: "Recibir",
        mostrarmodalTr: false,
        cargandoTr: false,
        arrTransferencia: [],
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrSegmentos: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        segmentoSelected: null,
        drivesSelected: [],
        disableDeleteFilters: true,
        disableApplyFilters: true,
        disableComboDrive: false,
        paginacion: {},
        mostrarModalEditar: false,
        btnLoading: false,
        nextPage: 0,
    }

    /**
     * Comportamiento del componente al recibir nuevos datos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        PedidosRequest.ListarSitiosSupervisor()
            .then(response => {
                state.sitios = response.data.sitio;
                return Pedidos.CargarEstatusPedido();
            })
            .then(response => {
                state.arrEstatusPedidos = response.data
                return CatalogosRequest.ListarRegiones();
            })
            .then(response => {
                state.arrRegiones = response.data
                state.cargando = false;
                state.disableComboDrive = ["Administrador", "SuperAdmin"].includes(localStorage.getItem("role")) ? true : false
                if (["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) {
                    return CatalogosRequest.ListarSegmentosConfigurados()
                } else {
                    return Promise.resolve({ data: [] });
                }
            })
            .then(response => {
                state.arrSegmentos = response.data;
                this.setState(state)
            })
            .catch(err => {
                openNotification("Ocurrió un error al cargar los sitios", "Error", false);
            })
    }

    /**
     * Acción que se ejecuta para cancelar un pedido
     */
    cancelarPedido = () => {
        let state = { ...this.state };
        let objEnviar = {}
        state.disableBtnCancelar = true;
        state.btnLoading = true;
        this.setState(state, () => {
            Pedidos.CancelarPedido(state.objCancelarPedido.id, objEnviar).then(response => {
                this.setState({ disableBtnCancelar: false, mostrarModalCancelar: false, btnLoading: false });
                openNotification("Se ha cancelado el pedido correctamente.", "Pedido cancelado con éxito", true)
            }).catch(err => {
                this.setState({ disableBtnCancelar: false, mostrarModalCancelar: false, btnLoading: false })
                openNotification("No se ha podido cancelar el pedido.", "Ocurrió un error al cancelar pedido", false)
            })
        });
    }

    /**
     * Función para procesar las entradas de texto y eliminar espacios así como
     * caracteres especiales
     * @param: input. entrada de texto al select
     * @param: option. opciones para el filtrado
     * @return: Booleano que indica si la opcion contiene al input
     */
    sanitizerTexto = (input, option) => {
        return option.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim()
            .toLowerCase().includes(input.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase())
    }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        let filtros = {};
        filtros.busqueda = state.filterTextPedidos.trim() !== "" ? state.filterTextPedidos.trim() : undefined
        filtros.estatus = (state.estatusSelected === undefined || state.estatusSelected === null) ? null : state.estatusSelected
        filtros.dateInicioPedido = state.datesPedido.length ? state.datesPedido[0] : null
        filtros.dateFinPedido = state.datesPedido.length ? state.datesPedido[1] : null
        filtros.dateInicioVencimiento = state.datesVencimiento.length ? state.datesVencimiento[0] : null
        filtros.dateFinVencimiento = state.datesVencimiento.length ? state.datesVencimiento[1] : null
        filtros.page = paginaSiguiente
        state.nextPage = paginaSiguiente;

        this.setState({ cargando: true }, () => {
            Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected, filtros).then(response => {
                state.paginacion = {
                    current: paginaSiguiente
                }
                response.data.results.forEach(element => {
                    element.fecha = moment(element.fecha).format("DD/MM/YYYY hh:mm A");
                    element.fecha_pedido = moment(element.fecha_pedido).format("DD/MM/YYYY");
                    element.almacen = (element.almacen === null || element.almacen === undefined) ? 'Almacén General' : element.almacen;
                    element.fecha_vencimiento = element.fecha_vencimiento === null ? null : moment(element.fecha_vencimiento).utcOffset(0, false).format("DD/MM/YYYY");
                    element.fecha_entrega = element.fecha_entrega === null ? null : moment(element.fecha_entrega).utcOffset(0, false).format("DD/MM/YYYY");
                    // if (element.pedido_extraordinario) {
                    //     element.etiquetas_nombre.push({ id: 99, descripcion: "Extraordinario" });
                    // }
                    // if (element.status === "Embarcado" &&
                    //     element.etiquetas_nombre.filter(function (e) { return e.descripcion === 'Parcial'; }).length === 0) {
                    //     element.embarcado_total = true
                    // }
                    // if (element.status === "Abierto" &&
                    //     element.etiquetas_nombre.filter(function (e) { return e.descripcion === 'Parcial'; }).length > 0) {
                    //     element.parcialAbierto = true
                    // }
                    // if (element.status.filter(function (e) { return e.descripcion === 'Pendiente'; }).length > 0) {
                    //     element.hay_pendientes = true
                    // }
                });
                state.arrPedidosRealizadosCopy = response.data.results;
                state.arrPedidosRealizadosFiltros = response.data.results;
                state.cargando = false;
                this.setState(state)
            }).catch(err => {
                openNotification("Ocurrió un error al realizar los filtrados", "Error al realizar filtros", false);
                this.setState({ cargando: false })
            })
        })
    }

    /**
     * Se ejecuta cuando se da clic en el combo 
     * para cambiar un sitio
     */
    onChangeSitio = (value) => {
        let state = { ...this.state };
        state.filterTextPedidos = '';
        state.estatusSelected = undefined;
        state.fechaPedido = [];
        state.fechaVencimiento = [];
        state.datesPedido = [];
        state.datesVencimiento = [];
        state.disableDeleteFilters = true;
        if (state.sitioPedidoSelected === undefined) {
            state.arrPedidosRealizados = []
            state.arrPedidosRealizadosCopy = []
            state.cargando = false;
            this.setState(state)
        } 
        else {
            this.setState({ cargando: true }, () => {
                Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected).then(response => {
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 10,
                        showTitle: false
                    }
                    
                    response.data.results.forEach((element, index) => {
                        element.fecha = moment(element.fecha).format("DD/MM/YYYY hh:mm A");
                        element.fecha_vencimiento = element.fecha_vencimiento === null ? null : moment(element.fecha_vencimiento).utcOffset(0, false).format("DD/MM/YYYY");
                        element.almacen = (element.almacen === null || element.almacen === undefined) ? 'Almacén General' : element.almacen;
                        element.fecha_entrega = element.fecha_entrega === null ? null : moment(element.fecha_entrega).utcOffset(0, false).format("DD/MM/YYYY");
                        // if (element.estatus.descripcion === "Embarcado") {
                        //     element.embarcado_total = true
                        // }
                        // if (element.estatus.descripcion === "Abierto") {
                        //     element.parcialAbierto = true
                        // }
                        // if (element.estatus.descripcion === 'Pendiente') {
                        //     element.hay_pendientes = true
                        // }
                    });
                    state.arrPedidosRealizados = response.data.results;
                    state.arrPedidosRealizadosCopy = response.data.results;
                    state.arrPedidosRealizadosFiltros = response.data.results;
                    state.cargando = false;
                    this.setState(state);
                }).catch(err => {
                    openNotification("Ocurrió un error al cargar los pedidos realizados", "Error al cargar pedidos realizados", false);
                    this.setState({ cargando: false })
                })
            })
        }
    }

    /**
     * Se ejecuta cuando se van a realizar filtrados
     */
    applyFilters = () => {
        let state = { ...this.state };
        let filtros = {};
        if (state.filterTextPedidos.trim() === "" &&
            state.estatusSelected === undefined &&
            !state.fechaPedido.length &&
            !state.fechaVencimiento.length
        ) {
            state.disableDeleteFilters = true
        } else {
            state.disableDeleteFilters = false
        }

        filtros.busqueda = state.filterTextPedidos.trim() !== "" ? state.filterTextPedidos.trim() : undefined
        filtros.estatus = (state.estatusSelected === undefined || state.estatusSelected === null) ? null : state.estatusSelected
        filtros.dateInicioPedido = state.datesPedido.length ? state.datesPedido[0].split('/').reverse().join('-') : null
        filtros.dateFinPedido = state.datesPedido.length ? state.datesPedido[1].split('/').reverse().join('-') : null
        filtros.dateInicioVencimiento = state.datesVencimiento.length ? state.datesVencimiento[0].split('/').reverse().join('-') : null
        filtros.dateFinVencimiento = state.datesVencimiento.length ? state.datesVencimiento[1].split('/').reverse().join('-') : null
        filtros.page = 1
        state.cargando = true
        this.setState(state, () => {
            Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected, filtros).then(response => {
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                }
                response.data.results.forEach(element => {
                    element.fecha = moment(element.fecha).format("DD/MM/YYYY hh:mm A");
                    element.fecha_vencimiento = element.fecha_vencimiento === null ? null : moment(element.fecha_vencimiento).utcOffset(0, false).format("DD/MM/YYYY");
                    element.almacen = 'Almacén General';
                    // if (element.pedido_extraordinario) {
                    //     element.etiquetas_nombre.push({ id: 99, descripcion: "Extraordinario" });
                    // }
                    // if (element.estatus_pedido_proveedor_nombre === "Embarcado" &&
                    //     element.etiquetas_nombre.filter(function (e) { return e.descripcion === 'Parcial'; }).length === 0) {
                    //     element.embarcado_total = true
                    // }
                    // if (element.estatus_pedido_proveedor_nombre === "Abierto" &&
                    //     element.etiquetas_nombre.filter(function (e) { return e.descripcion === 'Parcial'; }).length > 0) {
                    //     element.parcialAbierto = true
                    // }
                    // if (element.etiquetas_nombre.filter(function (e) { return e.descripcion === 'Pendiente'; }).length > 0) {
                    //     element.hay_pendientes = true
                    // }
                });
                state.arrPedidosRealizadosCopy = response.data.results
                state.arrPedidosRealizadosFiltros = response.data.results
                state.cargando = false;
                this.setState(state)
            }).catch(err => {
                openNotification("Ocurrió un error al realizar los filtrados", "Error al realizar filtros", false);
                this.setState({ cargando: false })
            })
        })
    }

    /**
     * Se ejecuta cuando se van a borrar filtrados
     */
    deleteFilters = () => {
        let state = { ...this.state };
        state.filterTextPedidos = '';
        state.estatusSelected = undefined;
        state.fechaPedido = [];
        state.fechaVencimiento = [];
        state.datesPedido = [];
        state.datesVencimiento = [];
        state.disableDeleteFilters = true;
        this.setState(state, this.applyFilters);
    }

    /**
     * Se ejecuta cuando se va a recibir un pedido
     */
    recibirPedido = (obj) => {

        let state = { ...this.state }
        let filtros = {};
        filtros.busqueda = state.filterTextPedidos.trim() !== "" ? state.filterTextPedidos.trim() : undefined
        filtros.estatus = (state.estatusSelected === undefined || state.estatusSelected === null) ? null : state.estatusSelected
        filtros.dateInicioPedido = state.datesPedido.length ? state.datesPedido[0] : null
        filtros.dateFinPedido = state.datesPedido.length ? state.datesPedido[1] : null
        filtros.dateInicioVencimiento = state.datesVencimiento.length ? state.datesVencimiento[0] : null
        filtros.dateFinVencimiento = state.datesVencimiento.length ? state.datesVencimiento[1] : null
        filtros.page = state.nextPage === 0 ? 1 : state.nextPage;
        
        this.setState({ cargando: true, mostrarModalRecibir: false }, () => {
            Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected, filtros).then(response => {
                state.paginacion = {
                    current: state.nextPage
                }
                response.data.results.forEach(element => {
                    element.fecha = moment(element.fecha).format("DD/MM/YYYY hh:mm A");
                    element.fecha_pedido = moment(element.fecha_pedido).format("DD/MM/YYYY");
                    element.almacen = (element.almacen === null || element.almacen === undefined) ? 'Almacén General' : element.almacen;
                    element.fecha_vencimiento = element.fecha_vencimiento === null ? null : moment(element.fecha_vencimiento).utcOffset(0, false).format("DD/MM/YYYY");
                });
                state.arrPedidosRealizadosCopy = response.data.results;
                state.arrPedidosRealizadosFiltros = response.data.results;
                state.cargando = false;
                state.mostrarModalRecibir = false
                this.setState(state)
            }).catch(err => {
                openNotification("Ocurrió un error al cargar los pedidos realizados", "Error al cargar pedidos realizados", false);
                this.setState({ cargando: false, mostrarModalRecibir: false })
            })
        });
    }

    /**
     * Función terminar de calificar el servicio del pedido
     * @param: obj. pedido actualizado
     */
    calificarPedido = (obj) => {
        let state = { ...this.state }
        state.arrPedidosRealizadosCopy.forEach(item => {
            if (item.id === state.objPedidoSelected.id) {
                item.calificacion_pedido = obj.calificacion_pedido;
            }
        });
        state.mostrarModalCalificar = false;
        this.setState(state)
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.segmentoSelected = null;
        state.sitioPedidoSelected = null;
        state.arrPedidosRealizados = [];
        state.arrPedidosRealizadosCopy = [];
        if (value === undefined) {
            state.regionSelected = null;
        } else {
            state.regionSelected = value
            CatalogosRequest.ListarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error al cargar sucursales",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.segmentoSelected = null;
        state.sitioPedidoSelected = null;
        state.arrPedidosRealizados = [];
        state.arrPedidosRealizadosCopy = [];
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value
            CatalogosRequest.ListarPlazasSucursal(value).then(response => {
                state.arrPlazas = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error al cargar plazas",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.sitioPedidoSelected = null;
        state.segmentoSelected = null;
        state.arrPedidosRealizados = [];
        state.arrPedidosRealizadosCopy = [];
        if (value === undefined) {
            state.plazaSelected = null;
            state.disableComboDrive = true;
        } else {
            state.plazaSelected = value
            state.disableComboDrive = true;
        }

        this.setState(state)
    }

    /**
     * Función que se cambia el segmento
     * @param: value. valor del id del segmento
     * @return: nada.
     */
    handleChangeSegmento = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.filterText = "";
        state.disableApplyFilters = true
        state.disableCreateMinimo = true;
        if (value === undefined) {
            state.segmentoSelected = null;
        } else {
            state.segmentoSelected = value
            state.disableComboDrive = false;
            CatalogosRequest.ListarSitios(state.plazaSelected, value).then(response => {
                state.sitios = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar los puntos de venta de la plaza.",
                    "Error al cargar drives",
                    false
                )
            })
        }
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handleSearchInput = (value) => {
        let state = { ...this.state };
        let buscar = false;
        if (value.trim() !== state.filterTextPedidos.trim()) buscar = true
        state.filterTextPedidos = value;
        if (value.trim() === "" &&
            state.estatusSelected === undefined &&
            !state.fechaPedido.length &&
            !state.fechaVencimiento.length
        ) {
            state.disableDeleteFilters = true;
        } else {
            state.disableDeleteFilters = false
        }
        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.applyFilters();
            }, 1000);
        }
    }

    /**
     * Acción que se ejecuta al consultar TR's del pedido
     * @param: record. objeto sobre el que se ejecuta la acción
     */
    consultarTR = (record) => {
        let state = { ...this.state }
        state.tipo_modal = "DetalleTr";
        state.objPedidoSelected = record;
        state.mostrarmodalTr = true;
        state.cargandoTr = true;
        state.arrTransferencia = []
        this.setState(state, () => {
            Pedidos.CargarInformacionTR(record.id)
            .then(response => {
                state.arrTransferencia = response.data
                state.cargandoTr = false;
                this.setState(state)
            })
            .catch(err => {
                openNotification(
                    err?.response?.data?.cuerpo,
                    err?.response?.data?.titulo,
                    false
                )
            })
        })
    }

    /**
     * Acción que se ejecuta para reenviar el pedido a sap
     * @param: record. objeto sobre el que se ejecuta la acción
     */
    reenviarSAP = (record) => {
        let state = { ...this.state }

        if(record.sync)
        {
            openNotification(
                "No se puede reenviar este pedido por que ya se ha enviado anteriormente.",
                "Error al reenviar el pedido",
                false
            );
            return;
        }

        state.cargando = true;
        this.setState(state,() => {
            Pedidos.EnviarPedidoSAP(record.id)
            .then(response => {
                openNotification(
                    response.data.cuerpo,
                    response.data.titulo,
                    true
                );

                return Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected);
            })
            .then(response => {
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 10,
                    showTitle: false
                }

                response.data.results.forEach((element, index) => {
                    element.fecha = moment(element.fecha).format("DD/MM/YYYY")
                    element.fecha_vencimiento = element.fecha_vencimiento != null ? moment(element.fecha_vencimiento).utcOffset(0, false).format("DD/MM/YYYY") : ''
                });
                state.arrPedidosRealizadosCopy = response.data.results;
                state.cargando = false;
                this.setState(state);
            })
            .catch(err => {
                state.cargando = false;
                this.setState(state);
                if(Array.isArray(err.response.data.cuerpo))
                {
                    const listadoErrores = err.response.data.cuerpo.map(e => `• ${e.MESSAGE}`).join('\n');
                    openNotification(
                        listadoErrores,
                        'Error',
                        false // es error
                    );
                }
                else {
                    openNotification(
                        err.response.data.cuerpo,
                        err.response.data.titulo,
                        false
                    );
                }
            });
        });
    }

    /**
     * Acción que se ejecuta para reenviar la confirmación del pedido a sap
     * @param: record. objeto sobre el que se ejecuta la acción
     */
    confirmarSAP = (record) => {
        let state = { ...this.state }

        if(record.sync)
        {
            openNotification(
                "No se puede reenviar este pedido por que ya se ha enviado anteriormente.",
                "Error al reenviar el pedido",
                false
            );
            return;
        }

        state.cargando = true;
        this.setState(state, () => {
            Pedidos.ReenviarRecibirPedido(record.id)
            .then(response => {
                openNotification(
                    response.data.cuerpo,
                    response.data.titulo,
                    true
                );

                return Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected);
            })
            .then(response => {
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 10,
                    showTitle: false
                }

                state.arrPedidosRealizadosCopy = response.data.results;
                state.cargando = false;
                this.setState(state);
            })
            .catch(err => {
                state.cargando = false;
                this.setState(state);
                if(Array.isArray(err.response.data.cuerpo))
                {
                    const listadoErrores = err.response.data.cuerpo.map(e => `• ${e.MESSAGE}`).join('\n');
                    openNotification(
                        listadoErrores,
                        'Error',
                        false // es error
                    );
                }
                else {
                    openNotification(
                        err.response.data.cuerpo,
                        err.response.data.titulo,
                        false
                    );
                }
            });
        });
    }

    /**
     * Acción que se ejecuta para reenviar la devolución a sap
     * @param: record. objeto sobre el que se ejecuta la acción
     */
    reenviarDevolucion = (record) => {
        let state = { ...this.state }

        if(record.sync)
        {
            openNotification(
                "No se puede reenviar la devolución por que ya se ha enviado anteriormente.",
                "Error al reenviar la devolución",
                false
            );
            return;
        }

        state.cargando = true;
        this.setState(state, () => {
            Pedidos.ReenviarDevolucionSAP(record.id)
            .then(response => {
                openNotification(
                    response.data.cuerpo,
                    response.data.titulo,
                    true
                );

                return Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected);
            })
            .then(response => {
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 10,
                    showTitle: false
                }

                state.arrPedidosRealizadosCopy = response.data.results;
                state.cargando = false;
                this.setState(state);
            })
            .catch(err => {
                state.cargando = false;
                this.setState(state);
                if(Array.isArray(err.response.data.cuerpo))
                {
                    const listadoErrores = err.response.data.cuerpo.map(e => `• ${e.MESSAGE}`).join('\n');
                    openNotification(
                        listadoErrores,
                        'Error',
                        false // es error
                    );
                }
                else {
                    openNotification(
                        err.response.data.cuerpo,
                        err.response.data.titulo,
                        false
                    );
                }
            });
        });
    }

    /**
     * Acción que se ejecuta para reenviar la confirmación de devolución a sap
     * @param: record. objeto sobre el que se ejecuta la acción
     */
    reenviarConfirmacionDevolucion = (record) => {
        let state = { ...this.state }

        if(record.sync)
        {
            openNotification(
                "No se puede reenviar la devolución por que ya se ha enviado anteriormente.",
                "Error al reenviar la devolución",
                false
            );
            return;
        }

        state.cargando = true;
        this.setState(state, () => {
            Pedidos.ReenviarConfirmaciónDevolucionSAP(record.id)
            .then(response => {
                openNotification(
                    response.data.cuerpo,
                    response.data.titulo,
                    true
                );

                return Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected);
            })
            .then(response => {
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 10,
                    showTitle: false
                }

                state.arrPedidosRealizadosCopy = response.data.results;
                state.cargando = false;
                this.setState(state);
            })
            .catch(err => {
                state.cargando = false;
                this.setState(state);
                if(Array.isArray(err.response.data.cuerpo))
                {
                    const listadoErrores = err.response.data.cuerpo.map(e => `• ${e.MESSAGE}`).join('\n');
                    openNotification(
                        listadoErrores,
                        'Error',
                        false // es error
                    );
                }
                else {
                    openNotification(
                        err.response.data.cuerpo,
                        err.response.data.titulo,
                        false
                    );
                }
            });
        });
    }

    /**
     * Se ejecuta para actualizar los pedidos.
     */
    actualizarPedidos = () => {
        let state = { ...this.state };
        if (state.sitioPedidoSelected !== undefined) {
            this.setState({ cargando: true }, () => {
                Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected).then(response => {
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 10,
                        showTitle: false
                    }

                    response.data.results.forEach((element, index) => {
                        element.fecha = moment(element.fecha).format("DD/MM/YYYY");
                        element.fecha_vencimiento = element.fecha_vencimiento === null ? null : moment(element.fecha_vencimiento).utcOffset(0, false).format("DD/MM/YYYY");
                        element.almacen = (element.almacen === null || element.almacen === undefined) ? 'Almacén General' : element.almacen;
                    });
                    state.arrPedidosRealizados          = response.data.results;
                    state.arrPedidosRealizadosCopy      = response.data.results;
                    state.arrPedidosRealizadosFiltros   = response.data.results;
                    state.cargando = false;
                    this.setState(state);
                }).catch(err => {
                    openNotification("Ocurrió un error al actualizar los pedidos realizados", "Error al actualizar pedidos realizados", false);
                    this.setState({ cargando: false })
                })
            })
        }
    }

    /**
     * Acción que se ejecuta para reenviar la confirmación del pedido a sap
     * @param: record. objeto sobre el que se ejecuta la acción
     */
    editarPedido = (obj) => {
        let state = { ...this.state }
        let filtros = {};
        filtros.busqueda = state.filterTextPedidos.trim() !== "" ? state.filterTextPedidos.trim() : undefined
        filtros.estatus = (state.estatusSelected === undefined || state.estatusSelected === null) ? null : state.estatusSelected
        filtros.dateInicioPedido = state.datesPedido.length ? state.datesPedido[0] : null
        filtros.dateFinPedido = state.datesPedido.length ? state.datesPedido[1] : null
        filtros.dateInicioVencimiento = state.datesVencimiento.length ? state.datesVencimiento[0] : null
        filtros.dateFinVencimiento = state.datesVencimiento.length ? state.datesVencimiento[1] : null
        filtros.page = state.nextPage

        this.setState({ cargando: true, mostrarModalEditar:false }, () => {
            Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected, filtros).then(response => {
                state.paginacion = {
                    current: state.nextPage
                }
                response.data.results.forEach(element => {
                    element.fecha_pedido = moment(element.fecha_pedido).format("DD/MM/YYYY");
                    element.almacen = (element.almacen === null || element.almacen === undefined) ? 'Almacén General' : element.almacen;
                    element.fecha_vencimiento = element.fecha_vencimiento === null ? null : moment(element.fecha_vencimiento).utcOffset(0, false).format("DD/MM/YYYY");
                });
                state.arrPedidosRealizadosCopy = response.data.results;
                state.arrPedidosRealizadosFiltros = response.data.results;
                state.cargando = false;
                state.mostrarModalRecibir = false
                this.setState(state)
            }).catch(err => {
                openNotification("Ocurrió un error al cargar los pedidos realizados", "Error al cargar pedidos realizados", false);
                this.setState({ cargando: false,  mostrarModalEditar:false })
            })
        });
        
    }

    getFilterActions = () => <>
        { this.state.isPos ? <Col span={this.isAdmin() ? 12 : 8}/> : ""}
        <Col span={this.state.isPos ? 3 : 2} >
            <div className={!this.state.arrPedidosRealizados.length ? "display-none" : "center-down"}>
                <Tooltip placement="top" title="Borrar filtros">
                    <Button type="default" icon="delete" className={this.state.disableDeleteFilters ? 'disableBtn' : ''} style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.1em' }} onClick={this.deleteFilters}></Button>
                </Tooltip>
            </div>
        </Col>
        <Col span={this.state.isPos ? 3 : 2}>
            <div className={!this.state.arrPedidosRealizados.length ? "display-none" : "center-down"}>
                <Tooltip placement="top" title="Actualizar Pedidos">
                    <Button icon='sync' style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.1em' }} onClick={this.actualizarPedidos}></Button>
                </Tooltip>
            </div>
        </Col>
    </>


    render() {
        const columnasPedidos = [
            {
                title: "N° pedido",
                dataIndex: "pedido_sap",
                key: "pedido_sap",
            },
            {
                title: "Referencia",
                dataIndex: "referencia",
                key: "referencia",
            },
            ["Drive"].includes(localStorage.getItem("role")) && {
                title: "Almacén proveedor",
                dataIndex: "almacen",
                key: "almacen",
            },
            {
                title: "Estatus",
                dataIndex: "estatus",
                key: "estatus",
                render: (estatus,record) => (
                    <div gap="4px 0">
                        <Tag
                            color={record.estatus === "Abierto" ? "#6fa8dcff" : record.estatus === "Terminado" ? "#092f50" : record.estatus === "Confirmado" ? "#3d85c6ff" : record.estatus === "Embarcado" ? "#0b5394ff" : (record.estatus === "Parcial" && record.embarcado === true) ? "#f9980b" : (record.estatus === "Complemento" && record.embarcado === true) ? "#f9980b" : ''}
                            key={estatus}>
                            {estatus}
                        </Tag>
                        <Tag
                            visible={ record.terminado_parcial }
                            color='blue'
                        >
                            Parcial
                        </Tag>
                        <Tag
                            visible={ record.extraordinario }
                            color='geekblue'
                        >
                            <Tooltip placement="top" title="Pedido generado fuera del calendario de pedido">
                                No calendarizado
                            </Tooltip>
                        </Tag>
                    </div>
                )
            },
            // {
            //     title: "Etiquetas",
            //     dataIndex: "etiquetas_nombre",
            //     key: "etiquetas_nombre",
            //     render: etiquetas_nombre => (
            //         <span>|
            //             { etiquetas_nombre.map((tag, index) => {
            //                 let color = tag.descripcion === 'Extraordinario' ? 'volcano' : tag.descripcion === 'Pendiente' ? 'gold' : tag.descripcion === 'Parcial' ? 'blue' : tag.descripcion === 'Backorder' ? 'red' : tag.descripcion === "Envío Directo" ? "magenta" : tag.descripcion === "Delegado" ? "geekblue" : '';
            //                 return <Tag color={color} key={tag.id}>{tag.descripcion}</Tag>;
            //               })
            //             }         
            //         </span>
            //     )
            // },
            {
                title: <Tooltip placement="top" title="Hora local de Hermosillo">Fecha de pedido</Tooltip>,
                dataIndex: "fecha",
                key: "fecha"
            },
            ["Drive"].includes(localStorage.getItem("role")) && {
                title: "Fecha de vencimiento",
                dataIndex: "fecha_vencimiento",
                key: "fecha_vencimiento"
            },
            ["Drive"].includes(localStorage.getItem("role")) &&  {
                title: "Fecha de entrega",
                dataIndex: "fecha_entrega",
                key: "fecha_entrega"
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <div>
                            <span className={ (record.sync === false && record.estatus === 'Pendiente SAP' && record.estatus !== 'Cancelado' && ["Drive", "Barista"].includes(localStorage.getItem("role"))) || (record.sync === false && record.estatus === 'Creado') ?  "" : "display-none"} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={ "Reenviar Pedido" }>
                                    <Button
                                        icon="sync"
                                        className="btnVerCrearGuardar"
                                        onClick={ () => { this.reenviarSAP(record) } }
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span className={ (record.sync === false && record.estatus === 'Recibir Pedido' && ["Drive", "Barista"].includes(localStorage.getItem("role"))) ?  "" : "display-none"} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={ "Recibir Pedido" }>
                                    <Button
                                        icon="sync"
                                        className="btnVerCrearGuardar"
                                        onClick={ () => { this.confirmarSAP(record) } }
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span className={ (record.sync === false && record.estatus === 'Devolucion' && ["Drive", "Barista"].includes(localStorage.getItem("role"))) ?  "" : "display-none"} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={ "Reenviar Devolución" }>
                                    <Button
                                        icon="sync"
                                        className="btnVerCrearGuardar"
                                        onClick={ () => { this.reenviarDevolucion(record) } }
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span className={ (record.sync === false && record.estatus === 'Confirmar Devolucion' && ["Drive", "Barista"].includes(localStorage.getItem("role"))) ?  "" : "display-none"} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={ "Confirmación Devolución" }>
                                    <Button
                                        icon="sync"
                                        className="btnVerCrearGuardar"
                                        onClick={ () => { this.reenviarConfirmacionDevolucion(record) } }
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            {/* <span className={record.existe_transferencia ? "" : "display-none"} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Ver detalle de TR's"}>
                                    <Button
                                        className="btnVerCrearGuardar"
                                        onClick={() => { this.consultarTR(record)} }
                                    >
                                        TR
                                    </Button>
                                </Tooltip>
                            </span> */}
                            <span className={record.estatus === "Cancelado" ? "display-none" : ""} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Ver detalle de pedido"}>
                                    <Button
                                        icon="eye"
                                        className="btnVerCrearGuardar"
                                        onClick={() => {
                                            let state = { ...this.state }
                                            state.tipo_modal = "Detalle";
                                            state.objPedidoSelected = record;
                                            state.mostrarModalDetalle = true;
                                            this.setState(state)
                                        }
                                        }
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span className={ 
                                (record.estatus === "Embarcado" && ["Drive", "Barista"].includes(localStorage.getItem("role"))) ||
                                ((record.estatus === "Parcial" && record.embarcado === true) && ["Drive", "Barista"].includes(localStorage.getItem("role"))) ||
                                ((record.estatus === "Complemento" && record.embarcado === true) && ["Drive", "Barista"].includes(localStorage.getItem("role"))) ? "" : "display-none"} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Recibir pedido"}>
                                    <Button
                                        icon="check-square"
                                        className="btnEmbarcar"
                                        onClick={() => {
                                            let state = { ...this.state }
                                            state.tipo_modal = "Recibir";
                                            state.objPedidoSelected = record;
                                            state.mostrarModalRecibir = true;
                                            this.setState(state)
                                        }
                                        }
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span className={(record.estatus === "Terminado" && record.calificacion_pedido === null && ["Drive", "Barista"].includes(localStorage.getItem("role"))) ? "" : "display-none"} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Calificar pedido"}>
                                    <Button
                                        icon="star"
                                        className="btnEmbarcar"
                                        onClick={() => {
                                            let state = { ...this.state }
                                            state.tipo_modal = "Calificar";
                                            state.objPedidoSelected = record;
                                            state.mostrarModalCalificar = true;
                                            this.setState(state)
                                        }
                                        }
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span className={
                                (( record.estatus === "Creado" && record.sync === true ) && !record.parcialAbierto && ["Drive"].includes(localStorage.getItem("role"))) || 
                                (( record.estatus === "Creado" && record.sync === true ) && !record.parcialAbierto &&  ["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) ? "" : "display-none"} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Cancelar pedido"}>
                                    <Button
                                        icon="close"
                                        className="btnCancelarPedido"
                                        onClick={() => {
                                            this.setState({ objCancelarPedido: record, mostrarModalCancelar: true })
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span className={
                                (( record.estatus === "Creado" ) && !record.parcialAbierto && ["Drive"].includes(localStorage.getItem("role"))) || 
                                (( record.estatus === "Creado" ) && !record.parcialAbierto && ["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) ? "" : "display-none"} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Actualizar pedido"}>
                                    <Button
                                        icon="edit"
                                        className="btnEditarPedido"
                                        onClick={() => {
                                            let state = { ...this.state }
                                            state.tipo_modal = "Editar";
                                            state.objPedidoSelected = record;
                                            state.mostrarModalEditar = true;
                                            this.setState(state)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                        </div>
                    </div>
                )
            }
        ].filter(Boolean);

        const columnasTr = [
            {
                title: "Folio GP",
                dataIndex: "folio_gp",
                key: "folio_gp",
            },
            {
                title: "Batch Number",
                dataIndex: "batch_number",
                key: "batch_number",
            },
            {
                title: "Estatus",
                dataIndex: "contabilizada",
                key: "contabilizada",
                render: contabilizada => (
                    <Tag color={contabilizada ? 'green' : 'red'}>{contabilizada ? 'Contabilizada' : 'No contabilizada'}</Tag>
                )
            }
        ]

        return (
            <ResponsiveCard
                id=""
                title="Módulo de pedidos realizados"
            >
                <div className="panel-block">
                    <Row gutter={12} >
                        <Col className={["Administrador", "SuperAdmin"].includes(localStorage.getItem("role")) ? '' : 'display-none'} span={6}>
                            <div className="center">Región:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una región">
                                <Select
                                    id="select-region-productos-modulo"
                                    showSearch
                                    autoFocus={true}
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    onChange={this.handleChangeRegion}
                                    value={this.state.regionSelected}
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrRegiones.length > 0 &&
                                        this.state.arrRegiones.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre_corto}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col className={["Administrador", "SuperAdmin"].includes(localStorage.getItem("role")) ? '' : 'display-none'} span={6}>
                            <div className="center">Sucursal:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una sucursal">
                                <Select
                                    id="select-sucursal-productos-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.regionSelected === null ? true : false}
                                    onChange={this.handleChangeSucursal}
                                    value={this.state.sucursalSelected}
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrSucursales.length > 0 &&
                                        this.state.arrSucursales.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col className={["Administrador", "SuperAdmin"].includes(localStorage.getItem("role")) ? '' : 'display-none'} span={6}>
                            <div className="center">Plaza:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una plaza">
                                <Select
                                    id="select-plaza-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.sucursalSelected === null ? true : false}
                                    onChange={this.handleChangePlaza}
                                    value={this.state.plazaSelected}
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrPlazas.length > 0 &&
                                        this.state.arrPlazas.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col className={["Administrador", "SuperAdmin"].includes(localStorage.getItem("role")) ? '' : 'display-none'} span={6}>
                            <div className="center">Segmento:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione un segmento">
                                <Select
                                    id="select-segmento-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.plazaSelected === null ? true : false}
                                    onChange={this.handleChangeSegmento}
                                    value={this.state.segmentoSelected}
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrSegmentos.length > 0 &&
                                        this.state.arrSegmentos.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col span={this.state.isPos && !this.isAdmin() ? 10 : 6}>
                            <Tooltip placement="top" title="Seleccione un sitio cliente">
                                <div className="center">Seleccione sitio cliente:</div>
                                <Select
                                    defaultActiveFirstOption={false}
                                    allowClear={true}
                                    showSearch
                                    notFoundContent={"No hay opciones"}
                                    style={{ width: "100%" }}
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.disableComboDrive}
                                    filterOption={(input, option) => this.sanitizerTexto(input, option.props.children)}
                                    value={this.state.sitioPedidoSelected}
                                    onChange={(value) => {
                                        this.setState({ sitioPedidoSelected: value }, this.onChangeSitio)
                                    }}
                                >
                                    <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.sitios.length > 0 &&
                                        this.state.sitios.map((obj, index) => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        {this.state.isPos ? this.getFilterActions() : ""}
                    </Row>
                    <Row gutter={12}>
                        <Col className={!this.state.arrPedidosRealizados.length ? "display-none" : ""} span={this.state.isPos ? 12 : 5} >
                            <Tooltip placement="top" title="Buscar pedidos sobre la tabla">
                                <div className="center">Buscar pedidos:</div>
                                <Input
                                    id="userInput"
                                    type="text"
                                    maxLength={100}
                                    value={this.state.filterTextPedidos}
                                    placeholder="Buscar por N° pedido / Almacén proveedor"
                                    onChange={(e) => this.handleSearchInput(e.currentTarget.value)}
                                />
                            </Tooltip>
                        </Col>
                        <Col className={!this.state.arrPedidosRealizados.length ? "display-none" : ""} span={this.state.isPos ? 12 : 4} >
                            <Tooltip placement="top" title="Buscar pedido por estatus">
                                <div className="center">Estatus pedido:</div>
                                <Select
                                    allowClear={true}
                                    style={{ width: '100%' }}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    defaultValue={null}
                                    showSearch
                                    defaultActiveFirstOption={false}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    value={this.state.estatusSelected}
                                    onChange={(e) => {
                                        this.setState({ estatusSelected: e, filterTextPedidos: "" }, () => {
                                            this.applyFilters()
                                        })
                                    }}
                                >
                                    <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrEstatusPedidos.length > 0 &&
                                        this.state.arrEstatusPedidos.map((obj, index) => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.descripcion}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col className={!this.state.arrPedidosRealizados.length ? "display-none" : ""} span={this.state.isPos ? 12 : 5}>
                            <Tooltip placement="top" title="Elegir fecha de pedido">
                                <div className="center">Fecha de pedido:</div>
                                <RangePicker
                                    format={dateFormat}
                                    placeholder={["Fecha Inicio", "Fecha Fin"]}
                                    value={this.state.fechaPedido}
                                    ranges={{
                                        'Hoy': [moment(), moment()],
                                        'Última Semana': [moment().subtract(6, 'days').startOf('day'), moment()],
                                        'Último Mes': [moment().subtract(29, 'days').startOf('day'), moment()]
                                    }}
                                    onChange={(dates, dateStrings) => {
                                        this.setState({ fechaPedido: dates, datesPedido: dateStrings, filterTextPedidos: "" }, () => {
                                            this.applyFilters()
                                        })
                                    }}
                                />
                            </Tooltip>
                        </Col>
                        <Col className={!this.state.arrPedidosRealizados.length ? "display-none" : ""} span={this.state.isPos ? 12 : 5}>
                            <Tooltip placement="top" title="Elegir fecha de vencimiento">
                                <div className="center">Fecha de vencimiento:</div>
                                <RangePicker
                                    format={dateFormat}
                                    placeholder={["Fecha Inicio", "Fecha Fin"]}
                                    value={this.state.fechaVencimiento}
                                    ranges={{
                                        'Hoy': [moment(), moment()],
                                        'Última Semana': [moment().subtract(6, 'days').startOf('day'), moment()],
                                        'Último Mes': [moment().subtract(29, 'days').startOf('day'), moment()]
                                    }}
                                    onChange={(dates, dateStrings) => {
                                        this.setState({ fechaVencimiento: dates, datesVencimiento: dateStrings, filterTextPedidos: "" }, () => {
                                            this.applyFilters()
                                        })
                                    }}
                                />
                            </Tooltip>
                        </Col>
                        { this.state.isPos ? "" : this.getFilterActions() }
                    </Row>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table
                            size="small"
                            pagination={this.state.paginacion}
                            locale={{ emptyText: 'No se han encontrado resultados.' }}
                            rowKey={ pedidos => pedidos.id }
                            columns={ columnasPedidos }
                            dataSource={ this.state.arrPedidosRealizadosCopy }
                            loading={ this.state.loading }
                            style={{marginTop: this.state.isPos ? "30px" : "auto"}}
                        />
                    </Spin>
                </div>
                <DetallePedidosRealizados
                    pedido_selected={this.state.objPedidoSelected}
                    esconderModal={(obj) => {
                        let state = { ...this.state }
                        if (obj !== null) {
                            state.arrPedidosRealizadosCopy.forEach((item, index) => {
                                if (item.id === obj.id) {
                                    state.arrPedidosRealizadosCopy[index] = obj
                                }
                            })
                            state.arrPedidosRealizadosFiltros.forEach((item, index) => {
                                if (item.id === obj.id) {
                                    state.arrPedidosRealizadosFiltros[index] = obj
                                }
                            })
                            state.arrPedidosRealizados.forEach((item, index) => {
                                if (item.id === obj.id) {
                                    state.arrPedidosRealizados[index] = obj
                                }
                            })
                        }
                        state.objPedidoSelected = null
                        state.mostrarModalDetalle = false;
                        this.setState(state)
                    }}
                    visible={this.state.mostrarModalDetalle}
                    tipo_modal={this.state.tipo_modal}
                >
                </DetallePedidosRealizados>
                <RecibirPedidoRealizado
                    pedido_selected={this.state.objPedidoSelected}
                    esconderModal={() => this.setState({ mostrarModalRecibir: false, objPedidoSelected: null })}
                    visible={this.state.mostrarModalRecibir}
                    recepcion={this.recibirPedido}
                    tipo_modal={this.state.tipo_modal}
                >
                </RecibirPedidoRealizado>
                <CalificarPedido
                    pedido_selected={this.state.objPedidoSelected}
                    esconderModalCalificar={() => this.setState({ mostrarModalCalificar: false })}
                    visible={this.state.mostrarModalCalificar}
                    calificarPedido={this.calificarPedido}
                    tipo_modal={this.state.tipo_modal}
                >
                </CalificarPedido>
                <Modal
                    title={<p style={{ textAlign: "center", marginBottom: 0 }}>Cancelación de pedido</p>}
                    onCancel={() => {
                        let state = { ...this.state };
                        state.mostrarModalCancelar = false;
                        this.setState(state);
                    }}
                    centered={true}
                    visible={this.state.mostrarModalCancelar}
                    maskClosable={false}
                    footer={[
                        <Button
                            className="btnCancelar"
                            key="back"
                            onClick={() => {
                                let state = { ...this.state };
                                state.mostrarModalCancelar = false;
                                this.setState(state);
                            }}>
                            Regresar
                        </Button>,
                        <Button
                            className="btnVerCrearGuardar"
                            key="submit"
                            type="primary"
                            disabled={this.state.disableBtnCancelar}
                            loading={this.state.btnLoading}
                            onClick={() => {
                                this.cancelarPedido();
                            }}
                        >
                            Continuar
                        </Button>
                    ]}
                >
                    <p style={{ textAlign: "center" }}>Se va a cancelar el pedido #{this.state.objCancelarPedido !== null ? this.state.objCancelarPedido.pedido_sap : ""}. ¿Desea continuar?</p>
                </Modal>
                <Modal
                    title={<p style={{ textAlign: "center", marginBottom: 0 }}>TR´s del pedido #{this.state.objPedidoSelected !== null && this.state.objPedidoSelected.numero_pedido} </p>}
                    onCancel={() => {
                        this.setState({ mostrarmodalTr: false, objPedidoSelected: null })
                    }}
                    centered={true}
                    visible={this.state.mostrarmodalTr}
                    maskClosable={false}
                    footer={[
                        <Button
                            className="btnCancelar"
                            key="back"
                            onClick={() => {
                                this.setState({ mostrarmodalTr: false, objPedidoSelected: null })
                            }}>
                            Regresar
                        </Button>
                    ]}
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargandoTr}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table
                            size="small"
                            pagination={{ showTitle: false }}
                            locale={{ emptyText: 'No se han encontrado resultados.' }}
                            rowKey={articulos => articulos.id}
                            columns={columnasTr}
                            dataSource={this.state.arrTransferencia}
                        />
                    </Spin>
                </Modal>
                <EditarPedidoRealizado
                    pedido_selected={this.state.objPedidoSelected}
                    esconderModal={() => this.setState({ mostrarModalEditar: false, objPedidoSelected: null})}
                    visible={this.state.mostrarModalEditar}
                    editarPedido={this.editarPedido}
                    tipo_modal={this.state.tipo_modal}
                >
                </EditarPedidoRealizado>
            </ResponsiveCard>
        )
    }
}

export default Form.create()(PedidosRealizados);